/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ThumbsUp({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.794 1a.6.6 0 0 0-.573.423L4.659 6.5H3a1.6 1.6 0 0 0-1.6 1.6v4.5A1.6 1.6 0 0 0 3 14.2h7.875a2.6 2.6 0 0 0 2.502-1.895l.984-3.492a2.6 2.6 0 0 0-2.502-3.305H9.822V3.6a2.6 2.6 0 0 0-2.6-2.6h-.428ZM4.4 13V7.7H3a.4.4 0 0 0-.4.4v4.5c0 .22.18.4.4.4h1.4Zm1.2 0h5.275a1.4 1.4 0 0 0 1.347-1.02l.984-3.492a1.4 1.4 0 0 0-1.347-1.78H9.222a.6.6 0 0 1-.6-.6V3.6a1.4 1.4 0 0 0-1.384-1.4L5.6 7.52V13Z" clipRule="evenodd" /></svg>;
}
;